module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "MAIN_PAGE",
    attrs: {
      "id": "d5e70"
    }
  }, [_c('p', {
    staticClass: "h5",
    attrs: {
      "id": "d4115341"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "tx36"
  }, [_c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d136761"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chap9_thegunse_9781569478004_epub_part9#d41151791",
      "id": "id13704"
    }
  }, [_vm._v("PART ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115371"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chap10_thegunse_9781569478004_epub_part10#d41151831",
      "id": "id13705"
    }
  }, [_vm._v("One")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115401"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chap11_thegunse_9781569478004_epub_part11#d41156131",
      "id": "id13706"
    }
  }, [_vm._v("Two")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115431"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap12_thegunse_9781569478004_epub_part12#d411511031",
      "id": "id13707",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115461"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap13_thegunse_9781569478004_epub_part13#d411515121",
      "id": "id13708",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115491"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap14_thegunse_9781569478004_epub_part14#d411518641",
      "id": "id13709",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115521"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap15_thegunse_9781569478004_epub_part15#d133461",
      "id": "id41157823",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d137151"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap16_thegunse_9781569478004_epub_part16#d141541",
      "id": "id13716",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d137111"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap17_thegunse_9781569478004_epub_part17#d411531281",
      "id": "id13717",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115551"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap18_thegunse_9781569478004_epub_part18#d411533561",
      "id": "id13718",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115581"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap19_thegunse_9781569478004_epub_part19#d411538021",
      "id": "id13719",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115621"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap20_thegunse_9781569478004_epub_part20#d411540871",
      "id": "id13720",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115651"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap21_thegunse_9781569478004_epub_part21#d411544091",
      "id": "id13721",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115681"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap22_thegunse_9781569478004_epub_part22#d411546431",
      "id": "id13722",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirteen")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115711"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap23_thegunse_9781569478004_epub_part23#d411549131",
      "id": "id13723",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fourteen")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d137261"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap24_thegunse_9781569478004_epub_part24#d136831",
      "id": "id41157748",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifteen")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d137281"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap25_thegunse_9781569478004_epub_part25#d138061",
      "id": "id13730",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sixteen")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115741"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap26_thegunse_9781569478004_epub_part26#d411560161",
      "id": "id13733",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d137321"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap27_thegunse_9781569478004_epub_part27#d123621",
      "id": "id13734",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seventeen")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115771"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap28_thegunse_9781569478004_epub_part28#d411561291",
      "id": "id13735",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eighteen")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115801"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap29_thegunse_9781569478004_epub_part29#d411563411",
      "id": "id13736",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nineteen")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115831"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap30_thegunse_9781569478004_epub_part30#d411566491",
      "id": "id13737",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115861"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap31_thegunse_9781569478004_epub_part31#d411569741",
      "id": "id13738",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-one")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115891"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap32_thegunse_9781569478004_epub_part32#d411572661",
      "id": "id13739",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-two")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115921"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap33_thegunse_9781569478004_epub_part33#d411576341",
      "id": "id13741",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-three")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115961"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap34_thegunse_9781569478004_epub_part34#d411579231",
      "id": "id13742",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-four")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d4115991"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap35_thegunse_9781569478004_epub_part35#d411583791",
      "id": "id13743",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-five")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d41151021"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap36_thegunse_9781569478004_epub_part36#d411587291",
      "id": "id13744",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-six")])]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d41151051"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap38_thegunse_9781569478004_epub_part38#d411592561",
      "id": "id13745",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cf3a45c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap2_thegunse_9781569478004_epub_part2.vue
// module id = 78
// module chunks = 0